<ng-template #container let-modal>
    <div class="modal-header">
        <div *ngIf="SignedDocument; then TemplateSignedDocumentTitle else TemplateNotSignedDocumentTitle">
        </div>  
        <button type="button" class="btn ms-auto close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <form (submit)="sendEvent()">
        <div class="modal-body">
            <div *ngIf="SignedDocument; then TemplateSignedDocument else TemplateNotSignedDocument">
                <span>{{'delete_popup.body' | translate}}</span>
            </div>
            <ng-template #TemplateSignedDocument>
                <span>{{'delete_popup.body' | translate}}</span>
            </ng-template>
            <ng-template #TemplateNotSignedDocument>
                <span>{{'delete_popup.bodySigned' | translate}}</span>
            </ng-template>
            <ng-template #TemplateSignedDocumentTitle>
                <h4 class="modal-title" id="modal-basic-title">{{'delete_popup.titleSigned' | translate}}</h4>
            </ng-template>
            <ng-template #TemplateNotSignedDocumentTitle>
                <h4 class="modal-title" id="modal-basic-title">{{'delete_popup.title' | translate}}</h4>
            </ng-template>

        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-success">{{'delete_popup.confirm' | translate}}</button>
            <button type="button" (click)="close()" class="btn btn-danger">{{'delete_popup.cancel' | translate}}</button>
        </div>
    </form>
</ng-template>